/** auto init sumoselect plugin
 *
 */

(function($) {
    $(".js-selectBox").each(function(index, element){
        var $element = $(element);
        var options = $element.data();

        if(options){
            $element.SumoSelect(options);
            if ($($element)[0].sumo.isMobile()) {
                $($element).parent().removeAttr('tabindex').removeAttr('role');
            }
        }else{
            $element.SumoSelect()
            if ($($element)[0].sumo.isMobile()) {
                $($element).parent().removeAttr('tabindex').removeAttr('role');
            }
        }
    });
})(jQuery);
